<p-dialog header="Export Barcodes" [(visible)]="visible" [modal]="true" [style]="{width: '400px'}"
    [closeOnEscape]="false" (onHide)="hideDialog()" [draggable]="false">

    <div class="field w-full">
        <label for="dateFrom" class="block font-medium mb-2">Select From Date</label>
        <p-datepicker id="dateFrom" [(ngModel)]="dateFrom" dateFormat="yy-mm-dd" [showIcon]="true" [iconDisplay]="'input'"
            class="w-full" inputStyleClass="w-full p-inputtext-sm" [appendTo]="'body'" [showOnFocus]="false"
            inputId="icondisplay" [readonlyInput]="true" [maxDate]="disableFutureDate"
            (onSelect)="onFromDateSelect($event)" placeholder="From Date">
        </p-datepicker>
    </div>
    <div class="field w-full">
        <label for="dateTo" class="block font-medium mb-2">Select To Date</label>
        <p-datepicker id="dateTo" [(ngModel)]="dateTo" dateFormat="yy-mm-dd" [showIcon]="true" [iconDisplay]="'input'"
            class="w-full" inputStyleClass="w-full p-inputtext-sm" [appendTo]="'body'" [showOnFocus]="false"
            inputId="icondisplay" [readonlyInput]="true" [minDate]="disablePastDate" [maxDate]="disableFutureDate"
            placeholder="To Date">
        </p-datepicker>
    </div>
    <div class="flex justify-content-end gap-2 mt-4 primary-btn-bg">
        <button pButton label="Export" [disabled]="dateFrom =='' && dateTo == ''" (click)="onExport()"
            [loading]="loading"></button>
    </div>

</p-dialog>